module.exports = __webpack_public_path__ + "static/media/whirlpoolIcon.382febd6.svg";